<template>
  <div class="dict">
    <el-row type="flex">
      <el-col :span="6">
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">
            <span>
              {{ $t('dict.currentChoice') }}：
              <span class="dictName" :title="rowData.dictName">{{ rowData.dictName }}</span>
            </span>
            <span class="i-icon">
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-create"
                @click="addDict"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-edit"
                @click="editDict"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-delete"
                @click="deleteDict"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px"
                icon-class="company-reset"
                @click="getData"
              />
            </span>
          </div>
          <el-input :placeholder="$t('dict.filter')" v-model="filterText"></el-input>
          <el-tree
            class="filter-tree"
            :data="data"
            :props="defaultProps"
            default-expand-all
            highlight-current
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            ref="tree"
            v-bind:style="{ height: heightTree, 'overflow-y': 'auto' }"
          ></el-tree>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card shadow="hover" class="box-card" title="字典缓存操作">
          <el-button type="primary" @click="refreshExpenseType()">刷新费用类型缓存</el-button>
        </el-card>
        <el-card shadow="hover" class="box-card">
          <div class="dict-search">
            <el-form label-position="right" label-width="auto" :model="query" ref="queryFrom">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('dict.dataName')" prop="dataName">
                    <!--输入框-->
                    <el-input v-model="query.dataName" clearable></el-input>
                  </el-form-item>
                </el-col>
                <!--单选-->
                <el-col :span="8">
                  <el-form-item :label="$t('dict.dataStatus')" prop="dataStatus">
                    <el-select v-model="query.dataStatus" style="width: 100%" filterable>
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="search-btns" :span="8" style="text-align: right">
                  <el-button type="primary" @click="search()">{{ $t('search.search') }}</el-button>
                  <el-button @click="resetForm('queryFrom')">{{ $t('search.reset') }}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('dict.dictDetail') }}</span>
            <span class="i-icon">
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-create"
                @click="addDictData"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-edit"
                @click="editDictData"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-delete"
                @click="deleteDictData"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px"
                icon-class="company-reset"
                @click="getListData"
              />
            </span>
          </div>
          <!--内容区域-->
          <sirui-table
            ref="siruiTable"
            :buttonList="[]"
            :loading="false"
            :data="tableData"
            :height="heightTable"
            :paging="true"
            :setting="false"
            :customVisible="false"
            :reserve="false"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
            @handleSelectionChange="handleSelectionChange"
          >
            <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
            <vxe-table-column
              v-for="(item, index) in columnList"
              :key="index"
              :fixed="item.fixed"
              :width="item.width"
              :sortable="item.sortable"
              :field="item.prop"
              :title="item.label"
            >
              <template slot-scope="scope">
                <span v-if="item.prop === 'dataStatus'">{{
                  { '0': $t('dict.startUsing'), '-1': $t('dict.disable') }[scope.row[item.prop]]
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </vxe-table-column>
          </sirui-table>
        </el-card>
      </el-col>
    </el-row>
    <addDict v-on:getData="getData" ref="addDict"></addDict>
    <editDict v-on:getData="getData" ref="editDict"></editDict>
    <addDictData v-on:getListData="getListData" ref="addDictData"></addDictData>
    <editDictData v-on:getListData="getListData" ref="editDictData"></editDictData>
  </div>
</template>
<script>
  import API from '../../api/systemManage/dict.js';
  import SiruiTable from '@/components/SiruiTable';
  import addDict from './addModal/addDict';
  import editDict from './editModal/editDict';
  import addDictData from './addModal/addDictData';
  import editDictData from './editModal/editDictData';

  export default {
    components: {
      SiruiTable,
      addDict,
      editDict,
      addDictData,
      editDictData,
    },
    name: 'dict',
    data() {
      return {
        filterText: '',
        data: [],
        rowData: {},
        query: {
          dataName: '',
          dataStatus: '',
        },
        load: false,
        tableData: [],
        multipleSelection: [],
        defaultProps: {
          children: null,
          label: 'dictName',
        },
      };
    },
    computed: {
      options() {
        return [
          {
            value: 0,
            label: this.$t('dict.startUsing'),
          },
          {
            value: -1,
            label: this.$t('dict.disable'),
          },
        ];
      },
      //表格显示字段
      columnList() {
        return [
          {
            prop: 'dataName',
            label: this.$t('dict.table.dataName'),
            width: 120,
          },
          {
            prop: 'dataValue',
            label: this.$t('dict.table.dataValue'),
            width: 120,
          },
          { prop: 'sortNo', label: this.$t('dict.table.sortNo'), width: 120 },
          {
            prop: 'dataStatus',
            label: this.$t('dict.table.dataStatus'),
            width: 120,
          },
          { prop: 'remark', label: this.$t('dict.table.remark') },
        ];
      },
      heightTable() {
        return window.innerHeight - 315 + 'px';
      },
      heightTree() {
        return window.innerHeight - 195 + 'px';
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getData();
      });
    },
    methods: {
      getData() {
        this.filterText = '';
        this.rowData = {};
        this.tableData = [];
        this.$axios.post(API.DICT_LIST_API).then((res) => {
          if (0 == res.data.code) {
            this.data = res.data.data;
            this.multipleSelection = [];
            this.$refs.siruiTable.clearCheckboxReserve();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      handleNodeClick(data) {
        this.rowData = data;
        this.$refs.siruiTable.setPageNum(1);
        this.getListData();
      },
      //新增数据字典值
      addDict() {
        this.$refs.addDict.openDialog(true);
      },
      //编辑数据字典
      editDict() {
        if (JSON.stringify(this.rowData) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('dict.editTips'),
            type: 'error',
          });
        } else {
          this.$refs.editDict.openDialog(true, this.rowData.id);
        }
      },
      //删除数据字典
      deleteDict() {
        if (JSON.stringify(this.rowData) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('dict.deleteTips'),
            type: 'error',
          });
        } else {
          this.$confirmAction()
            .then(() => {
              this.loading.startLoading();
              this.$axios
                .post(API.DELETE_DICT_API, {
                  id: this.rowData.id,
                  version: this.rowData.version,
                })
                .then((res) => {
                  this.loading.endLoading();
                  if (0 == res.data.code) {
                    this.$message({
                      type: 'success',
                      message: this.$t('message.success'),
                    });
                    this.getData();
                  } else {
                    this.$alert(res.data.msg);
                  }
                });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      resetForm(from) {
        this.$refs[from].resetFields();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getListData();
      },
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.getListData();
      },
      //新增数据字典数据值
      addDictData() {
        if (JSON.stringify(this.rowData) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('dict.addDateTips'),
            type: 'error',
          });
          return;
        }
        this.$refs.addDictData.openDialog(true, this.rowData);
      },
      //获取字典数据
      getListData() {
        this.load = true;
        this.query.dictCode = this.rowData.dictCode;
        this.query.pageSize = this.$refs.siruiTable.page.pageSize;
        this.query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.DICT_DATA_DICT_API, this.query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.reloadTable(this.tableData);
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
            this.multipleSelection = [];
            this.$refs.siruiTable.clearCheckboxReserve();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      editDictData() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('menu.editTreeTips'),
            type: 'error',
          });
          return;
        }
        this.multipleSelection[0].dictCode = this.rowData.dictCode;
        this.multipleSelection[0].dictName = this.rowData.dictName;
        this.$refs.editDictData.openDialog(true, this.multipleSelection[0]);
      },
      deleteDictData() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('dict.deleteDictDataTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.loading.startLoading();
            this.$axios
              .post(API.DELETE_DICT_DATA_API, {
                id: this.multipleSelection[0].id,
                version: this.multipleSelection[0].version,
              })
              .then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  //删除成功
                  this.getListData();
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //每页条数
      handleSizeChange() {
        this.getListData();
      },
      //第几页
      handleCurrentChange() {
        this.getListData();
      },
      //选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.dictName.indexOf(value) !== -1;
      },
      //刷新费用类型缓存
      refreshExpenseType() {
        this.loading.startLoading();
        this.$axios.post(API.RE_EXPENSETYPE, {}).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },

    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;

  .dictName {
    color: $maintheme;
    font-size: 14px;
    line-height: 14px;
    display: inline-block;
    width: 46%;
    text-overflow: ellipsis; /*只是起到注解作用*/
    white-space: nowrap; /*不让文本换行*/
    overflow: hidden; /*超出的部分显示...*/
  }
  .i-icon {
    float: right;
    i {
      cursor: pointer;
    }
  }
  .filter-tree {
    max-height: 580px;
    overflow: auto;
  }
  .dict-search {
    padding-top: 18px;
  }
  .el-button {
    border-radius: 3px;
    border: 1px solid $maintheme;
    color: $maintheme;
  }
  .el-button--primary {
    background-color: $maintheme;
    border-color: $maintheme;
    color: #fff;
  }
</style>
